import {Newable, PersistenceService} from '../../persistence.service';
import {Patient} from '../../../models/patient.model';
import {Observable, of} from 'rxjs';
import {Annotation} from '../../../models/annotation.model';
import {Vector3} from 'three';
import {Measurement} from '../../../models/measurement.model';
import {DataObject} from '../../../models/data-object.model';

export class MockService implements PersistenceService {

    private _patients: Array<Patient> = [
        new Patient().fromObject({id: '11', gender: 'male', birthDate: new Date('1970-01-01')}),
        new Patient().fromObject({id: '12', gender: 'male', birthDate: new Date('1970-01-01')}),
        new Patient().fromObject({id: '13', gender: 'male', birthDate: new Date('1970-01-01')}),
        new Patient().fromObject({id: '14', gender: 'male', birthDate: new Date('1970-01-01')}),
        new Patient().fromObject({id: '15', gender: 'male', birthDate: new Date('1970-01-01')}),
        new Patient().fromObject({id: '16', gender: 'male', birthDate: new Date('1970-01-01')}),
        new Patient().fromObject({id: '17', gender: 'male', birthDate: new Date('1970-01-01')}),
        new Patient().fromObject({id: '18', gender: 'male', birthDate: new Date('1970-01-01')}),
        new Patient().fromObject({id: '19', gender: 'male', birthDate: new Date('1970-01-01')}),
        new Patient().fromObject({id: '20', gender: 'male', birthDate: new Date('1970-01-01')}),
        new Patient().fromObject({id: '21', gender: 'male', birthDate: new Date('1970-01-01')})
    ];

    private _annotations: Array<Annotation> = [
        new Annotation().fromObject({id: '22', coordinates: new Vector3(3, 2, 1), notes: 'test', icon: 'circle', patient: '21'}),
        new Annotation().fromObject({id: '23', coordinates: new Vector3(1, 2, 3), notes: 'test2', icon: 'circle', patient: '20'}),
    ];

    private _measurements: Measurement[] = [];

    constructor() {}

    create(data: DataObject): Observable<void> {
        if (data instanceof Patient) {
            this._patients.push(data);
        } else if (data instanceof Annotation) {
            this._annotations.push(data);
        } else if (data instanceof Measurement) {
            this._measurements.push(data);
        }
        return new Observable<void>();
    }

    delete(id: string, type: Newable<DataObject>): Observable<any> {
        const data = this.getCollection(type);
        const idx = data.findIndex(obj => obj.id === id);
        data.splice(idx, 1);
        return new Observable<void>();
    }

    get<T extends DataObject>(id: string, type: Newable<T>): Observable<T> {
        return of(this.getCollection(type).find(obj => obj.id === id));
    }

    list<T extends DataObject>(type: Newable<T>): Observable<T[]> {
        return of(this.getCollection(type) as unknown as T[]);
    }

    update(data: DataObject): Observable<any> {
        this.getCollectionFromObj(data).find(obj => obj.id === data.id).fromObject(data);
        return new Observable();
    }

    private getCollection<T extends DataObject>(type: Newable<T>): Array<T> {
        // @ts-ignore
        if (type === Patient) {
            return this._patients as unknown as Array<T>;
        // @ts-ignore
        } else if (type === Annotation) {
            return this._annotations as unknown as Array<T>;
        // @ts-ignore
        } else if (type === Measurement) {
            return this._measurements as unknown as Array<T>;
        }
        return [];
    }

    private getCollectionFromObj(data: DataObject): Array<DataObject> {
        if (data instanceof Patient) {
            return this._patients;
            // @ts-ignore
        } else if (data instanceof Annotation) {
            return this._annotations;
            // @ts-ignore
        } else if (data instanceof Measurement) {
            return this._measurements;
        }
        return [];
    }


}
